<template>
    <div class="Office" v-if="lang">
        <md-whiteframe class="shadow shadow-faint">
            <div class="search search--field">
                <div class="icon">
                    <md-icon>search</md-icon>
                </div>
                <div class="input">
                    <input type="text" v-model="search.query" :placeholder="translate.pages.absence.index.search" style="outline:0;">
                    <span class="status">{{ searchIndicator }}</span>
                </div>
                <md-button v-if="addButton" class="md-icon-button md-raised button" @click.native="addAbsence">
                    <md-icon>add</md-icon>
                </md-button>
                <md-button v-else class="md-icon-button md-raised button-remove" @click.native="removeAbsences">
                    <md-icon>clear</md-icon>
                </md-button>
            </div>
        </md-whiteframe>
        <div class="table table--office table-mobile table--abs">
            <md-table-card v-if="absences.length > 0" class="table--wrap">
                <md-table md-sort="name" @sort="onSort" md-sort-by="name" @select="onSelect">
                    <md-table-header>
                        <md-table-row>
                            <md-table-head class="td-sort-name"  md-sort-by="name">{{ translate.pages.absence.index.fields.office }}</md-table-head>
                            <md-table-head class="hidden-mobile" md-sort-by="start">{{ translate.pages.absence.index.fields.start }}</md-table-head>
                            <md-table-head class="hidden-mobile" md-sort-by="end">{{ translate.pages.absence.index.fields.end }}</md-table-head>
                            <md-table-head class="hidden-mobile" md-sort-by="reason">{{ translate.pages.absence.index.fields.reason }}</md-table-head>
                            <md-table-head class="text-center hidden-mobile">{{ translate.pages.absence.index.fields.actions }}</md-table-head>
                        </md-table-row>
                    </md-table-header>
                    <md-table-body>
                        <md-table-row v-for="(row, rowIndex) in absences" :key="rowIndex" :md-item="row" md-selection>
                            <md-table-cell class='name--cell'>
                                <div class="img">
                                    <img :src="srcImage(row.office.path)">
                                </div>
                                <span class="name">{{ row.office.name }}</span>
                                <span class="subname visible-mobile">{{ row.reason }}</span>
                            </md-table-cell>
                            <md-table-cell class="double-content">
                                <span class="first-content">{{ row.start | formatTimeStamp }}</span>
                                <span class="last-content visible-lsmall">{{ row.end | formatTimeStamp }}</span>
                            </md-table-cell>
                            <md-table-cell class="hidden-lsmall">
                                <span>{{ row.end | formatTimeStamp }}</span>
                            </md-table-cell>
                            <md-table-cell class="hidden-mobile">
                                <span>{{ row.reason }}</span>
                            </md-table-cell>
                            <md-table-cell class="actions">
                                <md-icon class="icon-edit raised" @click.native="openDialog('edit', row, rowIndex)">edit</md-icon>
                                <md-icon class="icon-delete raised" @click.native="remove(row, rowIndex)">delete</md-icon>
                            </md-table-cell>
                        </md-table-row>
                    </md-table-body>
                </md-table>
                <md-dialog md-open-from="#custom" md-close-to="#custom" ref="edit"
                    :md-click-outside-to-close="close"
                    :md-esc-to-close="close">
                    <md-dialog-content>
                        <h3 class="dialog--title">{{ translate.pages.absence.edit.title }}</h3>
                        <hr>
                        <div class="content-main">
                            <md-layout md-gutter  class="modal-wrap">
                                <md-layout md-flex="100" class="container">
                                    <md-input-container style="margin-bottom: 5px" :class="{ 'md-input-invalid' : errors.office.invalid }">
                                        <label>{{ translate.pages.absence.edit.fields.office }}</label>
                                        <md-select name="office" id="office" v-model="currentAbsence.office">
                                            <md-option v-for="office in offices" :value="office.id" :key="office.id">{{ office.name }}</md-option>
                                        </md-select>
                                        <span class="md-error" v-if="errors.office.invalid">{{ errors.office.msg }}</span>
                                    </md-input-container>
                                </md-layout>
                                <md-layout md-flex-small="100" md-flex="50" class="amolpicker container-date">
                                    <label>{{ translate.pages.absence.edit.fields.start_date }}</label>
                                    <md-icon class="icon-calendar">today</md-icon>
                                    <date-picker :option="option" :limit="limit" class="picker" :date="startDate" v-model="currentAbsence.start_date"></date-picker>
                                    <small class="small-error" v-if="errors.start_date.invalid">{{ errors.start_date.msg }}</small>
                                </md-layout>
                                <md-layout md-flex-small="100" md-flex="50" class="amoltimer">
                                    <label>{{ translate.pages.absence.edit.fields.start_time }}</label>
                                    <md-icon>query_builder</md-icon>
                                    <vue-timepicker class="timer" v-model="currentAbsence.start_time_value" format="HH:mm" @change="updateTime($event, 'start_time')"></vue-timepicker>
                                    <span class="span-error">{{ errors.start_time.msg }}</span>
                                </md-layout>
                                <md-layout md-flex-small="100" md-flex="50" class="amolpicker container-date">
                                    <label>{{ translate.pages.absence.edit.fields.end_date }}</label>
                                    <md-icon class="icon-calendar">today</md-icon>
                                    <date-picker :option="option" :limit="limit" class="picker" :date="endDate" v-model="currentAbsence.end_date"></date-picker>
                                    <small class="small-error" v-if="errors.end_date.invalid">{{ errors.end_date.msg }}</small>
                                </md-layout>
                                <md-layout md-flex-small="100" md-flex="50" class="amoltimer">
                                    <label>{{ translate.pages.absence.edit.fields.end_time }}</label>
                                    <md-icon>query_builder</md-icon>
                                    <vue-timepicker class="timer" v-model="currentAbsence.end_time_value" format="HH:mm" @change="updateTime($event, 'end_time')"></vue-timepicker>
                                    <span class="span-error">{{ errors.end_time.msg }}</span>
                                </md-layout>
                                <md-layout md-flex="100" class="container">
                                    <md-checkbox md-theme="green" class="md-primary checkbox-list" id="interval" name="interval" v-model="currentAbsence.interval">
                                        <strong>{{ translate.pages.absence.edit.fields.absence_in_intervals }}</strong>
                                        <span class="color_form_placeholder normal">&nbsp;&nbsp;&nbsp; {{ translate.pages.absence.edit.fields.absence_in_intervals_description }}</span>
                                    </md-checkbox>
                                </md-layout>
                                <md-layout md-flex="100" class="container">
                                    <md-input-container :class="{ 'md-input-invalid' : errors.reason.invalid }">
                                        <label>{{ translate.pages.absence.edit.fields.reason }}</label>
                                        <md-input type="text" v-model="currentAbsence.reason" required></md-input>
                                        <span class="md-error" v-if="errors.reason.invalid">{{ errors.reason.msg }}</span>
                                    </md-input-container>
                                </md-layout>
                            </md-layout>
                        </div>
                    </md-dialog-content>
                    <md-dialog-actions class="modal--footer">
                        <md-button class="float-l md-primary sm-size md-size" @click.native="closeDialog('edit')">{{ translate.pages.absence.edit.cancel }}</md-button>
                        <md-button class="float-r md-primary sm-size md-size btn--blue" @click.native="closeDialog('edit', true)" :disabled="process">{{ translate.pages.absence.edit.save }}</md-button>
                    </md-dialog-actions>
                </md-dialog>
            </md-table-card>
            <div v-else>
                <h3 class="not-found mini-found" v-if="search.isQuery">{{translate.pages.absence.index.no_results}} "<strong>{{ search.query }}".</strong></h3>
                <h3 v-else>
                    <span class="not-found mini-found" v-if="fetchData">{{ translate.pages.absence.index.no_records }}</span>
                    <span v-else>
                        <div class="sk-rotating-plane"></div>
                    </span>
                </h3>
            </div>
        </div>
    </div>
</template>
<script>
    const swal = require('sweetalert2');
    import { doctor } from '../../../config/api.js';
    import moment from 'moment';
    import myDatepicker from 'vue-datepicker/vue-datepicker-es6.vue';
    import { datepicker, options } from '../../../config/datepicker.js';
    import VueTimepicker from 'vue2-timepicker';
    export default {
        data: () => ({
            startDate: { time: datepicker.now_format},
            endDate: { time: datepicker.now_format},
            option: options,
            limit: [
                {
                    type: 'fromto',
                    from: moment().subtract(1, "days"),
                    to: ''
                }
            ],
            absences: [],
            offices: [],
            currentAbsence: {},
            errors: {
                'office': {
                    'invalid': false,
                    'msg': ''
                },
                'start_date': {
                    'invalid': false,
                    'msg': ''
                },
                'start_time': {
                    'invalid': false,
                    'msg': ''
                },
                'end_date': {
                    'invalid': false,
                    'msg': ''
                },
                'end_time': {
                    'invalid': false,
                    'msg': ''
                },
                'reason': {
                    'invalid': false,
                    'msg': ''
                },
                'response': {
                    'invalid': false,
                    'msg': ''
                }
            },
            selectedData: [],
            fetchData: false,
            currentIndex: -1,
            disabled: true,
            close: false,
            addButton: true,
            sort: {},
            page: {},
            search: {
                query: '',
                queryIsDirty: false,
                isCalculating: false,
                isQuery: false
            },
            process: false,
        }),
        computed: {
            // Search indicator
            searchIndicator: function () {
                if (this.search.isCalculating) {
                    return '⟳'
                } else if (this.search.queryIsDirty) {
                    return '...'
                } else {
                    return '✓'
                }
            },
            // Get path office
            path() {
                if(!this.currentOffice.path){
                    return 'https://api.agendaenlinea.cl/image/default_avatar.png';
                }
                return this.currentOffice.path;
            },
            // Get language
            translate(){
                return this.$store.getters.language.app[this.lang].prestador;
            },
            // Get lang
            lang(){
                return this.$store.getters.language.lang;
            }
        },
        created() {
            let url = doctor.api.absences;
            let url_offices = doctor.api.offices;
            let parent = this.$auth.getParent();
            if(parent)
            {
                url += '?parent=' + parent;
                url_offices += '?parent=' + parent;
            }
            // Get absences
            this.$http.get(url,{
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                }).then(response => {
                    let data = response.data.data;
                    this.absences = data;
                    this.fetchData = true;
                }).catch(error => {
                    console.log(error);
                    //alert("No se pudo cargar las comunidades");
                });
            // Get offices
            this.$http.get(url_offices,{
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                }).then(response => {
                    let data = response.data.data;
                    // storage comunities
                    this.offices = data;
                }).catch(error => {
                    console.log(error);
                    //alert("No se pudo cargar las comunidades");
                });
        },
        methods: {
            // Get Path avatar
            srcImage(path){
                if(path){
                    return path;
                }
                return 'https://api.agendaenlinea.cl/image/default_avatar.png';
            },
            // Open Modal by Absence
            openDialog(ref, row, rowIndex) {
                this.$refs[ref].open();
                this.currentIndex = rowIndex;
                let _row = JSON.parse(JSON.stringify(row));
                let _start_date = moment(_row.start);
                let _end_date = moment(_row.end);
                let interval = false;
                if(_row.interval){
                    interval = true;
                }
                this.startDate.time = _start_date.format('DD/MM/YYYY');
                this.endDate.time = _end_date.format('DD/MM/YYYY');
                this.currentAbsence = {
                    'start_date': this.startDate.time,
                    'start_time': _start_date.format('HH:mm'),
                    'start_time_value': { HH: _start_date.format('HH'), mm: _start_date.format('mm') },
                    'end_date': this.endDate.time,
                    'end_time': _end_date.format("HH:mm"),
                    'end_time_value': { HH: _end_date.format('HH'), mm: _end_date.format('mm') },
                    'reason': _row.reason,
                    'office': _row.office_id,
                    'interval': interval,
                    'id': _row.id
                }
            },
            // Close Modal
            closeDialog(ref, save) {
                if(save)
                {
                    this.update(ref);
                }else{
                    this.currentIndex = -1;
                    this.$refs[ref].close();
                }
            },
            // Route for add Absence
            addAbsence() {
                this.$router.push({'name': 'AbsenceAdd'});
            },
            // Show button add
            onSelect(data) {
                this.selectedData = data;
                this.$forceUpdate();
                (_.size(this.selectedData) >= 1) ? this.addButton = false : this.addButton = true;
            },
            // Sort offices
            onSort(sort) {
                this.offices = _.orderBy(this.offices, [item => item[sort.name]], sort.type);
            },
            // Pagination
            onPagination(page) {
                this.page = page;
            },
            // Remove Absence
            remove(row, rowIndex){
                swal('', this.translate.pages.absence.index.actions.delete , 'warning')
                    .then( () => {
                        let url = doctor.api.absences + '/' + row.id;
                        let parent = this.$auth.getParent();
                        if(parent)
                        {
                            url += '?parent=' + parent;
                        }
                        this.$http.delete(url,{
                                    headers: {
                                        Authorization : 'Bearer '+ this.$auth.getToken(),
                                    }
                            }).then(response => {
                                let data = response.data.data;
                                swal('', response.data.msg, 'success')
                                    .then( () => {
                                        this.absences.splice(rowIndex, 1);
                                    }, (dismiss) => {
                                        this.absences.splice(rowIndex, 1);
                                    });
                            }).catch(error => {
                                console.log(error);
                            });
                    }, (dismiss) => {
                        //console.log(dismiss);
                    });
            },
            // Remove absences
            removeAbsences(){
                swal('', this.translate.pages.absence.index.actions.delete, 'warning')
                    .then( () => {
                        var promises = [];
                        for(let index in this.selectedData)
                        {
                            let url = doctor.api.absences + '/' + this.selectedData[index].id;
                            let parent = this.$auth.getParent();
                            if(parent)
                            {
                                url += '?parent=' + parent;
                            }
                            promises.push(this.$http.delete(url, {
                                            headers: {
                                                Authorization : 'Bearer '+ this.$auth.getToken(),
                                            }
                                        }));
                        }
                        Promise.all(promises)
                            .then(values => {
                                var msg = '';
                                var quantites = 0;
                                values.forEach( response => {
                                    if(response.status == 200)
                                    {
                                        msg = response.data.msg;
                                        quantites++;
                                        let url = response.config.url;
                                        let id = url.split("/absences/")[1];
                                        this.absences.forEach( (absence,index) => {
                                            if(absence.id == id){
                                                this.absences.splice(index,1);
                                            }
                                        });
                                    }else{
                                        // Not deleted
                                    }
                                });
                                swal('', quantites + msg.substring(1), 'success')
                                    .then( () => {
                                        this.selectedData = [];
                                        this.addButton = true;
                                    }, (dismiss) => {
                                        this.selectedData = [];
                                        this.addButton = true;
                                    });
                            });
                    }, (dismiss) => {
                        //console.log(dismiss);
                    });
            },
            // Method to search
            expensiveOperation: _.debounce( function() {
                this.search.isCalculating = true;
                let data = {'query': this.search.query, 'type': 'absences'};
                let url = doctor.api.search;
                var self = this;
                let parent = this.$auth.getParent();
                if(parent)
                {
                    url += '?parent=' + parent;
                }
                this.$http.post(url, data, {
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                }).then(response => {
                    let data = response.data.data;
                    this.absences = data;
                    this.search.isCalculating = false;
                    this.search.queryIsDirty = false;
                    this.search.isQuery = self.search.query.length > 0;
                }).catch(error => {
                    console.log(error);
                    //alert("No se pudo cargar las comunidades");
                });
            }, 500),
            // Update absence
            update(ref){
                let error = false;
                this.currentAbsence.start_date = this.startDate.time;
                this.currentAbsence.end_date = this.endDate.time;
                if(this.currentAbsence.office.length == 0)
                {
                    this.errors.office.invalid = true;
                    this.errors.office.msg = this.translate.pages.absence.add.validations.no_office;
                    error = true;
                }else{
                    this.errors.office.invalid = false;
                    this.errors.office.msg = "";
                }
                if(this.currentAbsence.start_date.length == 0)
                {
                    this.errors.start_date.invalid = true;
                    this.errors.start_date.msg = this.translate.pages.absence.add.validations.no_startdate;
                    error = true;
                }else{
                    this.errors.start_date.invalid = false;
                    this.errors.start_date.msg = "";
                }
                if(this.currentAbsence.start_time.length == 0)
                {
                    this.errors.start_time.invalid = true;
                    this.errors.start_time.msg = this.translate.pages.absence.add.validations.no_starttime;
                    error = true;
                }else{
                    this.errors.start_time.invalid = false;
                    this.errors.start_time.msg = "";
                }
                if(this.currentAbsence.end_date.length == 0)
                {
                    this.errors.end_date.invalid = true;
                    this.errors.end_date.msg = this.translate.pages.absence.add.validations.no_enddate;
                    error = true;
                }else{
                    this.errors.end_date.invalid = false;
                    this.errors.end_date.msg = "";
                }
                if(this.currentAbsence.end_time.length == 0)
                {
                    this.errors.end_time.invalid = true;
                    this.errors.end_time.msg = this.translate.pages.absence.add.validations.no_endtime;
                    error = true;
                }else{
                    this.errors.end_time.invalid = false;
                    this.errors.end_time.msg = "";
                }
                if(this.currentAbsence.reason.length == 0)
                {
                    this.errors.reason.invalid = true;
                    this.errors.reason.msg = this.translate.pages.absence.add.validations.no_reason;;
                    error = true;
                }else{
                    this.errors.reason.invalid = false;
                    this.errors.reason.msg = "";
                }
                if(error){
                    return false;
                }
                // udpate Absence
                this.process = true;
                let url = doctor.api.absences + '/' + this.currentAbsence.id;
                let parent = this.$auth.getParent();
                if(parent)
                {
                    url += '?parent=' + parent;
                }
                this.$http.put(url, this.currentAbsence, {
                            headers: {
                                Authorization : 'Bearer '+ this.$auth.getToken(),
                            }
                    }).then(response => {
                        this.process = false;
                        this.absences[this.currentIndex] = response.data.data;
                        this.currentAbsence = {};
                        this.$refs[ref].close();
                        this.currentIndex = -1;
                        swal('', response.data.msg, 'success');
                    }).catch(error => {
                        this.process = false;
                        if(error.response.status === 422){
                            let data = error.response.data;
                            for(let index in data)
                            {
                                this.errors[index].invalid = true;
                                let messages = '';
                                data[index].forEach( item => messages += item + ' ');
                                this.errors[index].msg = messages;
                            }
                            this.errors.response.invalid = false;
                        }else if(error.response.status === 404){
                            this.errors.response.invalid = true;
                            this.errors.response.msg = error.response.data.message;
                        }
                    });
            },
            // Update time
            updateTime($event, target){
                this.currentAbsence[target] = $event.data.HH + ':' + $event.data.mm;
            }
        },
        watch: {
            // Search query
            'search.query': function () {
                this.search.queryIsDirty = true;
                this.expensiveOperation();
            }
        },
        components: {
            'date-picker': myDatepicker,
            VueTimepicker
        }
    }
</script>
<style lang="stylus" scoped>
    @import '../../../assets/styles/variables/color.styl'
    @import '../../../assets/styles/loading.styl'
    .Office
        .search
            display flex
            padding 1em
            .icon
                text-align center
                width 50px
            .input
                width 100%
                input
                    border 0
                    height 2em
                    width 100%
            .button
                background-color color_main
                color white
                position absolute
                right 1em
                top 2.45em
                &:hover
                    background-color color_main
                    color white
            .button-remove
                background-color color_error
                color white
                position absolute
                right 1em
                top 2.45em
                &:hover
                    background-color color_error
                    color white
            .status
                color color_form_placeholder
                font-size 1.5em
                left 0.35em
                position absolute
                top 0.75em
        .table
            padding 3em 2em 2em 2em
            .img
                border-radius 50%
            .name
                margin-left .5em
            .text-center
                text-align center
            .icon-edit
                color color_notifications
                cursor pointer
                font-size 22px
            .icon-delete
                color color_error
                cursor pointer
                font-size 22px
            .enabled
                border 1px solid color_form_placeholder
                border-radius 1em
                color color_form_placeholder
                margin 0 auto
                padding 0.5em 1.5em
                text-align center
                width 110px
                &.active
                    border 1px solid color_confirm
                    color color_confirm
    .content-main
        .container
            padding 0.25em 1em
            .picture
                position relative
                .icon
                    background-color color_main
                    border 3px solid white
                    border-radius 50%
                    bottom -1em
                    cursor pointer
                    height 40px
                    padding 8px
                    position absolute
                    right -1em
                    width 40px
                    text-align center
                    i
                        color white
                        position relative
                        left -3px
                        top -3px
            .multiple
                border 1px solid color_form_border
                border-radius 5px
                width 100%
                .title
                    margin 0.5em
                    color color_form_placeholder
                .select
                    overflow-y scroll
                    overflow-x hidden
                    margin 0.25em
                    height 110px
                    .option
                        width 95%
                        margin 0.25em
            .subtitle
                margin-top .5em
                color color_form_placeholder
            .w100
                width 100%
            .w90
                width 90%
            .w10
                width 10%
                margin-top 0
            .span-error
                color #ff5722
    .color_form_placeholder
        color color_form_placeholder

    @import '../../../assets/styles/responsive.styl'
    @media(max-width: 390px)
        .sm-size
            padding 0 1em!important
</style>



// WEBPACK FOOTER //
// Index.vue?3edc5b89